<script setup lang="ts">
import {MAIN_EMAIL} from '~/constants';
</script>

<template>
    <section class="information">
        <div class="container">
            <h2 class="information__title" data-aos="fade-up" data-aos-duration="900">
                Подробная информация о наших услугах и ценах
            </h2>

            <div class="information-content" data-aos="fade-up" data-aos-duration="900" data-aos-delay="100">
                <span class="information-content__text">Если у вас есть вопросы по стоимости наших услуг, нужна консультация или вы хотите получить наше КП – просто напишите нам.</span>
                <span class="information-content__text">Мы <span class="information-content__bold">вам</span> всегда рады!</span>
            </div>

            <NuxtLink
                :to="`mailto:${MAIN_EMAIL}`"
                class="information__link"
                    data-aos="fade-up"
                    data-aos-duration="900"
                    data-aos-delay="200"
            >
                {{ MAIN_EMAIL }}
            </NuxtLink>
        </div>
    </section>
</template>

<style scoped lang="scss">
@import 'styles/information';
</style>
